import { differenceInDays } from 'date-fns';

const DISMISS_KEY = 'download-banner-dismissed';

export const checkIfDownloadBannerIsDismissed = () => {
	const dismissed = localStorage.getItem(DISMISS_KEY);
	return dismissed && differenceInDays(new Date(), new Date(dismissed)) < 7;
};

export const storeDownloadBannerDismiss = () => {
	localStorage.setItem(DISMISS_KEY, new Date().toISOString());
};
